import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const TagIcon = ({ title = 'Tag', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 23 23" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M20.698 1.32l-7.7-.786a.889.889 0 00-.718.256L.966 12.103a.889.889 0 000 1.257l8.485 8.486a.889.889 0 001.257 0l11.314-11.314a.889.889 0 00.256-.719l-.786-7.7a.889.889 0 00-.794-.793zm-.9 1.695l.669 6.558L10.08 19.96l-7.228-7.228L13.239 2.345l6.558.67zm-2.176 1.86a2.667 2.667 0 10-3.77 3.771 2.667 2.667 0 003.77-3.77zm-1.257 1.257a.889.889 0 11-1.257 1.257.889.889 0 011.257-1.257z" />
  </CreateIconComponent>
);

export default TagIcon;
